<template>
  <hr class="mt-5" v-if="!porpHideHr" />
  <div class="row gy-5">
    <div class="col-sm-6" v-if="!porpHideDataInclusao">
      <InputCustom
        label="Data e Hora de Inclusão:"
        :disabled="true"
        :model-value="dataInclusao"
      />
    </div>
    <div class="col-sm-6" v-if="!porpHideUsuarioInclusao">
      <InputCustom
        label="Usuário de Inclusão"
        :disabled="true"
        :model-value="usuarioInclusao"
        placeholder=""
      />
    </div>
    <div class="col-sm-6" v-if="!porpHideDataAlteracao">
      <InputCustom
        label="Data e Hora de Alteração"
        :disabled="true"
        v-model="dataAlteracao"
      />
    </div>
    <div class="col-sm-6" v-if="!porpHideUsuarioAlteracao">
      <InputCustom
        label="Usuário de Alteração"
        :disabled="true"
        :model-value="usuarioAlteracao"
        placeholder=""
      />
    </div>
  </div>
</template>
<script lang="ts">
import { convertDateBrComHora } from "@/core/helpers/convertDate";
import { defineComponent, PropType, reactive, watch, toRefs } from "vue";
export default defineComponent({
  name: "Grade-Edicao",
  data() {
    return {
      dataInclusao: "",
      dataAlteracao: "",
    };
  },
  props: {
    propPayload: {
      type: Object as PropType<any>,
      required: true,
      default: () => {
        return {};
      },
    },
    porpHideHr: {
      type: Boolean,
      required: false,
      default: false,
    },
    porpHideDataInclusao: {
      type: Boolean,
      required: false,
      default: false,
    },
    porpHideUsuarioInclusao: {
      type: Boolean,
      required: false,
      default: false,
    },
    porpHideUsuarioAlteracao: {
      type: Boolean,
      required: false,
      default: false,
    },
    porpHideDataAlteracao: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const data = reactive({
      dataInclusao: "",
      dataAlteracao: "",
      usuarioInclusao: "",
      usuarioAlteracao: "",
    });

    const carregarCamposAuditoria = (payload: Record<string, unknown>) => {
      if (!payload) {
        return;
      }

      const dataInclusaoValor =
        payload.dataInclusao ?? payload.data_inclusao ?? "";
      const dataAlteracaoValor =
        payload.dataAlteracao ?? payload.data_alteracao ?? "";

      data.dataInclusao = dataInclusaoValor
        ? convertDateBrComHora(dataInclusaoValor as string | number)
        : "";
      data.dataAlteracao = dataAlteracaoValor
        ? convertDateBrComHora(dataAlteracaoValor as string | number)
        : "";
      data.usuarioInclusao = String(
        payload.usuarioInclusao ?? payload.usuario_inclusao ?? ""
      ).trim();
      data.usuarioAlteracao = String(
        payload.usuarioAlteracao ?? payload.usuario_alteracao ?? ""
      ).trim();
    };

    watch(
      () => props.propPayload,
      (payload: Record<string, unknown>) => {
        carregarCamposAuditoria(payload);
      },
      { immediate: true, deep: true }
    );

    return {
      ...toRefs(data),
    };
  },
});
</script>
